import "./CategoryDetailCarouselComponent.scss";
import { useEffect } from "react";
import React from "react";
import globals from "../../../../../../config/appconfig";
import { useNavigate } from "react-router-dom";
import { routesMap } from "../../../../../../routes";
import {CarouselBI} from "bootstrap-italia";


/**
 * @function CategoryDetailCarouselComponent CategoryDetailCarouselComponent components
 * @returns {JSX.Element}
*/
const CategoryDetailCarouselComponent = ({ images, voci }) => {
    const currentCarousel = React.createRef();
    const navigate = useNavigate();

    useEffect(() => {
        if (images) {
            if (images?.length) {
                const elementList = [].slice.call(document.querySelectorAll('.splide'));
                const elements = document.getElementsByClassName("splide__pagination");
                while(elements.length > 0){
                    elements[0].parentNode.removeChild(elements[0]);
                }
                elementList.map(function (element) {
                    return new CarouselBI(element);
                });
            }
        }
    }, [images]);

    const navigateToCategory = (idCategory) => {
        navigate(`${routesMap.DETAGLIO_CATEGORIA}/${idCategory}`);
    }

    return (
        images?.length ?
            <div ref={currentCarousel} className="it-carousel-wrapper splide CategoryDetailCarouselComponent" data-bs-carousel-splide>
                <div className="splide__track">
                    <ul className="splide__list">
                        {images?.map(img => {
                            return (
                                <li key={ img.link } className="splide__slide" >
                                    <div className="it-single-slide-wrapper">
                                        <div className="it-card-wrapper">
                                            <div className="it-card it-card-img it-card-full-height no-after">
                                                <div className="img-responsive-wrapper">
                                                    <div className="img-responsive">
                                                        <div className="img-wrapper">
                                                            <img
                                                                src={`${globals["app-url-bucket"]}${img.link}`}
                                                                title={voci?.find(item => item?.idContenuto === img.id)?.nome}
                                                                alt={img?.testoAlternativo}
                                                                className="img-fluid"
                                                                style={{ cursor: "pointer"}}
                                                                onClick={() => navigateToCategory(img.id)}
                                                                /*width={2000}
                                                                height={970}*/
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div >
            : <></>

    );
};

CategoryDetailCarouselComponent.propTypes = {};

CategoryDetailCarouselComponent.defaultProps = {};

export default CategoryDetailCarouselComponent;